import Axios from "axios";
import React, { Component } from "react";
import { getUser } from "../../actions/session";
import {
  ALL_ACCOUNT_LIST,
  ALL_CARRIER_LIST,
  BILLING_CDR_URL,
  LOGIN_URL,
} from "../../config/rest_endpoints";
import Container from "../common/application_container";
import CustomLoader from "../common/loader";
import Pagination from "react-js-pagination";
import CustomModal from "../common/modal";
import Select from "react-select";
import MiniCarrierTable from "./miniCarrierTable";
import { Notifications } from "../common/notification";
import { Redirect } from "react-router-dom";
import { miniWrapText } from "../../actions/helper";
// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";
// import the react-json-view component
import ReactJson from 'react-json-view';

// Initializing start and end date with specific times
const firstDate = moment().subtract(1, 'days').startOf('day'); // 12:00 AM of the previous day
const lastDate = moment().startOf('day').add(12, 'hours'); // 12:00 PM of the current day


class CdrBilling extends Component {
  constructor(props) {
    super(props);
    // initializing states
    this.state = {
      tableData: [],
      User: getUser(),
      startDate: firstDate,
      endDate: lastDate,
      isGetting: false,
      isLong: false,
      activePage: 1,
      itemsCount: 10,
      totalCount: null,
      destination: "",
      source: "",
      isCarrierModal: false,
      isStirHeaderrModal: false,
      isStirPayloadModal: false,
      carrierData: [],
      stirHeader: [],
      stirPayload: [],
      callId: "",
      isLoginURL: false,
      selectedAccount: "",
      accountOptions: [],
      selectedCarrier: "",
      carrierOptions: [],
      selectedtype: { value: "all", label: "All" },
      callTypes: [
        { value: "all", label: "All" },
        { value: "successful", label: "Successfull" },
        { value: "failed", label: "Failed" },
      ],
      counter: 0,
      isBtnSpin:false,
      isDownLoadSpin: false
    };

    this.carrierModalClose = this.carrierModalClose.bind(this);
    this.carrierModalOpen = this.carrierModalOpen.bind(this);
    // stirheader model
    this.stirHeaderModalOpen = this.stirHeaderModalOpen.bind(this);
    this.stirHeaderModalClose = this.stirHeaderModalClose.bind(this);
    // stirpayload model
    this.stirPayloadModalOpen = this.stirPayloadModalOpen.bind(this);
    this.stirPayloadModalClose = this.stirPayloadModalClose.bind(this);

    this.handleDate = this.handleDate.bind(this);
    this.getCdrList = this.getCdrList.bind(this);
    this.textShortness = this.textShortness.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.onHandleDestination = this.onHandleDestination.bind(this);
    this.onHandleSource = this.onHandleSource.bind(this);
  }

  componentDidMount() {
    this.getCdrList();
    this.getAllAccount();
    this.getAllCarrier();
    this.setState({isBtnSpin:false, isDownLoadSpin:false})
  }

  getAllAccount() {
    const { User } = this.state;

    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_ACCOUNT_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          console.log(`resp`, resp);
          const list = resp.map((row) => {
            row["label"] = row["accountName"];
            row["value"] = row["id"];
            return row;
          });
          this.setState({ accountOptions: list });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  getAllCarrier() {
    const { User } = this.state;

    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_CARRIER_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          console.log("responseeeeeeee",resp );
          const list = resp.map((row) => {
            row["label"] = row["name"];
            row["value"] = row["domain"];
            return row;
          });
          this.setState({ carrierOptions: list });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  // carrier model open
  carrierModalOpen(data, id) {
    console.log("data :>> ", data);
    this.setState({ isCarrierModal: true, carrierData: data, callId: id });
  }
  // carrier model close
  carrierModalClose() {
    this.setState({ isCarrierModal: false });
  }

  //  stirheader model open
  stirHeaderModalOpen(data, id) {
    console.log("data :>> ", data);
    this.setState({ isStirHeaderrModal: true, stirHeader: data, callId: id });
  }
  //  stirheader model close
  stirHeaderModalClose() {
    this.setState({ isStirHeaderrModal: false });
  }

  //  stirpayload model open
  stirPayloadModalOpen(data, id) {
    console.log("data :>> ", data);
    this.setState({isStirPayloadModal: true, stirPayload: data, callId: id });
  }
  //  stirpayload model close
  stirPayloadModalClose() {
    this.setState({ isStirPayloadModal: false });
  }


  // handle date and time on selection of datetime picker
  handleDate(date, value) {
    console.log("date pickers",date);
    console.log("value",value);
    if (value === "start") {
      this.setState({ startDate: date }, () => {
        console.log("start", this.state.startDate);
      });
    } else {
      this.setState({ endDate: date }, () => {
        console.log("end", this.state.endDate);
      });
    }
  }

  onHandleDestination(e) {
    this.setState({ destination: e.target.value }, () => {
      console.log("search :>> ", this.state.destination);
    });
  }

  onHandleSource(e) {
    this.setState({ source: e.target.value }, () => {
      console.log("search :>> ", this.state.source);
    });
  }

  handlePageChange(pageNumber) {
    this.setState(
      {
        activePage: pageNumber,
      },
      () => {
        this.getCdrList();
      }
    );
  }

  // on filter we are getting CdrLit
  getCdrList(type) {
    console.log("type", type);
    const {
      User,
      startDate,
      endDate,
      activePage,
      itemsCount,
      destination,
      isBtnSpin,
      isDownLoadSpin,
      source,
      selectedAccount,
      selectedCarrier,
      selectedtype,
    } = this.state;

    var payLoad = {
      startDate: Math.floor(startDate.toDate().getTime() / 1000.0),
      endDate: Math.floor(endDate.toDate().getTime() / 1000.0),
      destination: destination,
      source: source,
      accountID: selectedAccount.value,
      carrierID: selectedCarrier.value,
      cdrType: selectedtype.value,
    };
    console.log("startDateeeeeeeeee :>> ", payLoad.startDate);
    console.log("endDate :>> ", payLoad.endDate);
    console.log("payLoad :>> ", payLoad);
    this.setState({ isGetting: true, isBtnSpin:true, isDownLoadSpin:false });
    var headers = { Authorization: "Bearer " + User.token };
    if (type === "download") {
      this.setState({ isGetting: false, isBtnSpin:false, isDownLoadSpin:true });
      Axios.post(
        `${BILLING_CDR_URL}/search/cdrs?page=${activePage}&limit=${itemsCount}&download=true`,
        payLoad,
        { headers }
      )
      
        .then((res) => {
          if (res) {
            var resp = res.data;
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({ isGetting: false,isBtnSpin:false, isDownLoadSpin:false });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin:false,
            isDownLoadSpin:false
          });
        });
    } else {
      this.setState({ isGetting: true });

      Axios.post(
        `${BILLING_CDR_URL}/search/cdrs?page=${activePage}&limit=${itemsCount}`,
        payLoad,
        { headers }
      )
        .then((res) => {
          if (res) {
            const resp = res.data.data;
            console.log("result response", resp);
            console.log("result response", resp.callID
            );
            this.setState({
              tableData: resp,
              isGetting: false,
              isBtnSpin:false,
              isDownLoadSpin:false,
              totalCount: res.data.pageinfo.totalCount,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin:false,
            isDownLoadSpin:false
          });
        });
    }
  }

  loadMoreCount() {
    this.setState({ counter: this.state.counter + 1 });
  }

  LoadMore(data) {
    const totalArray = data;

    const arraySlice = totalArray.slice(0, 10);
    console.log(`arraySlice`, arraySlice);
    this.setState({
      tableData: arraySlice,
    });
  }

  textShortness(row) {
    this.setState({
      isLong: !this.state.isLong,
    });
  }

  renderCdrsTable() {
    const { tableData, isLong } = this.state;
    console.log("tableData",tableData)
    var nullData = (
      <div className="ml-4 mt-2">
        <div
          className="dataTables_info"
          id="DataTables_Table_0_info"
          role="status"
          aria-live="polite"
        >
          Showing 0 of 0 entries
        </div>
        <div
          className="dataTables_paginate paging_simple_numbers"
          id="DataTables_Table_0_paginate"
        ></div>
      </div>
    );
    if (!tableData.length) {
      return nullData;
    } else {
      return tableData.map((row, idx) => {
        var callId = row.callID;
        return (
            <tr key={idx}>
              <td style={{textAlign: 'center'}}>{row.accountName}</td>
              <td style={{textAlign: 'center'}}>{row.setupTime}</td>
              <td style={{textAlign: 'center'}}>{row.answerTime}</td>
              <td style={{textAlign: 'center'}}>{row.callSetupTime === '' ? "....." : row.callSetupTime}</td>
              <td style={{textAlign: 'center'}}>
                {isLong ? callId : callId.substring(0, 8)}
                <i
                    className="icon-menu ml-1"
                    onClick={this.textShortness.bind(this, row)}
                    style={{cursor: "pointer"}}
                ></i>
              </td>
              <td style={{textAlign: 'center'}}>{row.source}</td>
              <td style={{textAlign: 'center'}}>{row.destination}</td>
              <td style={{textAlign: 'center'}}>{row.lrnDestination}</td>
              <td style={{textAlign: 'center'}}>{row.state}</td>
              <td style={{textAlign: 'center'}}>{row.fromState}</td>
              <td style={{textAlign: 'center'}}>{row.toState}</td>
              <td style={{textAlign: 'center'}}>{row.customerIP}</td>
              <td style={{textAlign: 'center'}}>{row.hangupCode}</td>
              <td style={{textAlign: 'center'}}>{row.hangupCause}</td>
              <td style={{textAlign: 'center'}}>{row.internalReason}</td>
              <td className="edit-button">
                {row.carriers === "" ? (
                    "N/A"
                ) : (
                    <i
                        className=" icon-eye-plus  icon-2x"
                        onClick={this.carrierModalOpen.bind(
                            this,
                            row.carriers,
                            row.callID
                        )}
                    ></i>
                )}
              </td>
              <td style={{textAlign: 'center'}}>{row["RPM"]}</td>
              <td style={{textAlign: 'center'}}>{row["carrierRPM"]}</td>
              <td style={{textAlign: 'center'}}>{row.duration}</td>
              <td style={{textAlign: 'center'}}>{row.carrierDuration}</td>
              <td style={{textAlign: 'center'}}>{row.billedDuration}</td>
              <td style={{textAlign: 'center'}}>{row.carrierBilledDuration}</td>
              <td style={{textAlign: 'center'}}>{row.billed}</td>
              <td style={{textAlign: 'center'}}>{row.paid}</td>
              <td style={{textAlign: 'center'}}>{row.profit}</td>
              <td className="edit-button">
                {row.stirHeader === "" ? (
                    "N/A"
                ) : (
                    <i
                        className=" icon-eye-plus  icon-2x"
                        onClick={this.stirHeaderModalOpen.bind(
                            this,
                            row.stirHeader,
                            row.callID
                        )}
                    ></i>
                )}
              </td>
              {/* <td className="edit-button">
              {row.stirPayload === "" ? (
                "N/A"
              ) : (
                <i
                  className=" icon-eye-plus  icon-2x"
                  onClick={this.stirPayloadModalOpen.bind(
                    this,
                    row.stirPayload,
                    row.callID
                  )}
                ></i>
              )}
            </td> */}
            </tr>
        );
      });
    }
  }

  downloadAllResult() {}

  render() {
    const {
      startDate,
      endDate,
      isGetting,
      activePage,
      itemsCount,
      totalCount,
      isCarrierModal,
      isStirHeaderrModal,
      isStirPayloadModal,
      selectedAccount,
      accountOptions,
      selectedCarrier,
      carrierOptions,
      callTypes,
      selectedtype,
      isBtnSpin,
      isDownLoadSpin
    } = this.state;
    console.log(`selectedAccount`, selectedAccount);

    const wrappedCallId = miniWrapText(this.state.callId);
    // console.log("wrappedCallId",wrappedCallId);

    // carrier model
    let carrierTable = {
      details: {
        info: (
          <h6>
              <b>Call ID :</b> {wrappedCallId}
          </h6>
        ),
        msg: <MiniCarrierTable table={this.state.carrierData} />,
      },
      confirmBtn: { label: "Update", action: "" },
      crossBtn: { action: this.carrierModalClose },
      cancelBtn: { label: "Cancel", action: this.carrierModalClose },
    };
    // stirheader model
    let stirHeaderModel = {
      details: {
        info: (
          <h6>
              <b>Call ID :</b> {wrappedCallId}
          </h6>
        ),
        msg: (
          <div className="p-2" style={{overflowX:'auto'}}>
            <ReactJson src={{
              "STIR Header": this.state.stirHeader
            }} />
          </div>
        ),
      },
      confirmBtn: { label: "Update", action: "" },
      crossBtn: { action: this.stirHeaderModalClose },
      cancelBtn: { label: "Cancel", action: this.stirHeaderModalClose },
    };
    // stirpayload model
    let stirPayloadModel = {
      details: {
        info:(
          <h6>
            <b>Call ID :</b> {wrappedCallId}
          </h6>
        ) ,
        msg: (
          <div className="p-2">
            <ReactJson src={{
              "STIR Header": this.state.stirPayload
            }} />
        </div>
        ),
      },
      confirmBtn: { label: "Update", action: "" },
      crossBtn: { action: this.stirPayloadModalClose },
      cancelBtn: { label: "Cancel", action: this.stirPayloadModalClose },
    };
    if (this.state.isLoginURL === true) {
      return <Redirect to={LOGIN_URL}></Redirect>;
    }
    return (
      <Container title="CDRs" title1="Table" icon="fa fa-credit-card">
        {/* carrier model */}
        <CustomModal
          visibility={isCarrierModal}
          modalType={"success"}
          details={carrierTable.details}
          showBtns={false}
          cancelBtn={carrierTable.cancelBtn}
          crossBtn={carrierTable.crossBtn}
        />
        {/* stir header model */}
         <CustomModal
         modalSize={'large'}
          visibility={isStirHeaderrModal}
          modalType={"success"}
          details={stirHeaderModel.details}
          showBtns={false}
          cancelBtn={stirHeaderModel.cancelBtn}
          crossBtn={stirHeaderModel.crossBtn}
        />
        {/* stir payload model */}
        <CustomModal
          visibility={isStirPayloadModal}
          modalType={"success"}
          details={stirPayloadModel.details}
          showBtns={false}
          cancelBtn={stirPayloadModel.cancelBtn}
          crossBtn={stirPayloadModel.crossBtn}
        />

        <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
          <div class="d-flex justify-content-start flex-wrap bg-light rounded border p-0 mb-2">
            <div class="py-2 px-3 mb-1">
              <div class="">
                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Start Date</label>
                <div class="input-group">
                <DateRangePicker
                    onCallback={(date) => this.handleDate(date, "start")}
                    initialSettings={{
                      singleDatePicker: true,
                      timePicker: true,
                      showDropdowns: true,
                      startDate: moment(startDate),
                      locale: {
                        format: 'MMMM/DD/YYYY h:mm A',
                      },
                    }}
                >
                  <input  type="text" className="form-control" style={{ minWidth: '300px' }} />
                </DateRangePicker>
                  <span class="input-group-prepend">
                    {/* <span class="date-input_icon input-cdr-date" ><i class="icon-calendar22 " style={{ color: 'white' }}></i></span> */}
                  </span>
                </div>
              </div>
            </div>
            <div class="py-2 px-3 mb-1">
              <div class="">
                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">End Date</label>
                <div class="input-group">
                <DateRangePicker
                    onCallback={(date) => this.handleDate(date, "end")}
                    initialSettings={{
                      singleDatePicker: true,
                      timePicker: true,
                      showDropdowns: true,
                      startDate: moment(endDate),
                      locale: {
                        format: 'MMMM/DD/YYYY h:mm A',
                      },
                    }}
                >
                  <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                </DateRangePicker>
                  {/* <span class="input-group-prepend">
                      <span class="date-input_icon input-cdr-date" ><i class="icon-calendar22 blue-icon-group-color" style={{ color: 'white' }}></i></span>
                  </span> */}
                </div>
              </div>
            </div>
            <div class="py-2 px-3 mb-1">
              <div className="" style={{ marginTop: "2.6em" }}>
                <button
                  type="submit"
                  className="main-button btn btn-success btn-sm "
                  onClick={this.getCdrList.bind(this, "download")}
                >
                  Download CSV <i class={`${isDownLoadSpin ? 'icon-spinner4 spinner' : 'icon-download7'} ml-2`}></i>
                </button>
              </div>
            </div>
          </div>
          {/* row 1 */}
          <div class="d-flex justify-content-start flex-wrap bg-light rounded border p-0 mb-3" style={{zIndex:'1'}}>
            <div className="py-2 px-3 mb-1">
              <div className="">
                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Destination </label>
                <div class="input-group w-20em">
                  <input
                    type="text"
                    class="form-control "
                    value={this.state.destination}
                    onChange={this.onHandleDestination}
                    placeholder="Type destination"
                  />
                  <span class="input-group-prepend">
                    {/* <span class="date-input_icon input-cdr-date"><i class="fa fa-search"></i></span> */}
                  </span>
                </div>
              </div>
            </div>
            {/* 1st section closed here  */}
            <div className="py-2 px-3 mb-1">
              <div className="">
                  <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Source </label>
                  <div className="input-group w-20em">
                    <input
                      type="text"
                      className="form-control "
                      value={this.state.source}
                      onChange={this.onHandleSource}
                      placeholder="Type source"
                    />
                    <span className="input-group-prepend">
                      {/* <span class="date-input_icon input-cdr-date"><i class="fa fa-search"></i></span> */}
                    </span>
                  </div>
                </div>
            </div>
            {/* 2nd section closed here  */}
            <div class="py-2 px-3 mb-1">
              <div className="">
                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14 ">Account Select</label>
                <Select
                  value={selectedAccount}
                  onChange={(selectedAccount) =>
                    this.setState({ selectedAccount })
                  }
                  options={accountOptions}
                  className="w-20em"
                />
              </div>
            </div>
            {/* 3rd section closed here  */}
            <div class="py-2 px-3 mb-1">
              <div className="">
                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14 ">Call Type</label>
                <Select
                  value={selectedtype}
                  onChange={(selectedtype) => this.setState({ selectedtype })}
                  options={callTypes}
                  className="w-20em"
                />
              </div>
            </div>
            {/* 4th section closed here  */}
            <div class="py-2 px-3 mb-1">
              <div className="">
                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14 ">Carrier Select</label>
                <Select
                  value={selectedCarrier}
                  onChange={(selectedCarrier) =>
                    this.setState({ selectedCarrier })
                  }
                  options={carrierOptions}
                  className="w-20em"
                />
              </div>
            </div>
            {/* 5th section closed here  */}
            <div class="py-2 px-3 mb-1">
              <div className="" style={{ marginTop: "2.5em" }}>
                <button
                  type="submit"
                  className="main-button btn btn-success btn-sm "
                  onClick={this.getCdrList}
                >
                  Filter <i class={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                </button>
              </div>
            </div>
            {/* 6th section closed here  */}
          </div>
          {/* row 2 */}
          <div
           style={{zIndex:'0'}}
            id="DataTables_Table_0_wrapper"
            className="dataTables_wrapper no-footer"
          >
            {/* <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..." aria-controls="DataTables_Table_0" />
                                </label>
                            </div>
                        </div> */}
            <div
              className="datatable-scroll "
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "56em",
              }}
            >
              <table
                className="table-style table table-striped dataTable no-footer"
                id="DataTables_Table_0"
                role="grid"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead>
                <tr className="stickeyHeader table-heading-style" style={{zIndex: '1'}}>
                  <th>Account</th>
                  <th>Setup Time</th>
                  <th>Answer Time</th>
                  <th>Call Setup Time</th>
                  <th>Call ID</th>
                  <th>Source</th>
                  <th>Destination</th>
                  <th>Destination LRN</th>
                  <th>Jurisdiction</th>
                  <th>From State</th>
                  <th>To State</th>
                  <th>Customer Ip</th>
                  <th>Hangup Code</th>
                  <th>Hangup Cause</th>
                  <th>Internal Reason</th>
                  <th>Carriers</th>
                  <th>RPM</th>
                  <th>Carrier RPM</th>
                  <th>Duration</th>
                  <th>Carrier Duration</th>
                  <th>Billed Duration</th>
                  <th>Carrier Billed Duration</th>
                  <th>Revenue</th>
                  <th>Cost</th>
                  <th>Profit</th>
                  <th>Stir Header</th>
                  {/* <th>Stir Payload</th> */}
                </tr>
                </thead>
                <tbody>
                  {isGetting ? <CustomLoader /> : this.renderCdrsTable()}
                </tbody>
              </table>
            </div>
            <div className="datatable-footer mt-1">
              {totalCount >= 9 ? (
                <div>
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCount}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              ) : (
                ""
              )}
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
              ></div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}
export default CdrBilling;
